/* Section-local product education. No purchase, cart or customer state. */
if (!customElements.get('park-product-explorer')) {
  customElements.define('park-product-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const panels = [...this.querySelectorAll('[data-guide-panel]')];
      const tabs = this.querySelector('[data-guide-tabs]');
      if (!panels.length || !tabs) return;
      const choices = [...tabs.querySelectorAll('[data-choice]')];
      this.select = (id) => {
        if (!panels.some(panel => panel.dataset.guidePanel === id)) return;
        panels.forEach(panel => { panel.hidden = panel.dataset.guidePanel !== id; });
        choices.forEach(tab => {
          const selected = tab.dataset.choice === id;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.querySelectorAll('.park-product-explorer__marker').forEach(marker => marker.setAttribute('aria-pressed', String(marker.dataset.choice === id)));
        this.querySelectorAll('[data-choice-image]').forEach(img => { img.hidden = img.dataset.choiceImage !== id; });
      };
      tabs.setAttribute('role', 'tablist');
      choices.forEach(tab => tab.setAttribute('role', 'tab'));
      panels.forEach((panel, index) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', choices[index].id);
        panel.tabIndex = 0;
      });
      const click = event => { const choice = event.target.closest('[data-choice]'); if (choice && this.contains(choice)) this.select(choice.dataset.choice); };
      const keydown = event => {
        const index = choices.indexOf(event.target);
        if (index < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + choices.length) % choices.length;
        this.select(choices[next].dataset.choice); choices[next].focus();
      };
      const blockSelect = event => { if (this.contains(event.target)) this.select(event.detail.blockId); };
      this.addEventListener('click', click);
      this.addEventListener('keydown', keydown);
      document.addEventListener('shopify:block:select', blockSelect);
      this.cleanup = () => {
        this.removeEventListener('click', click);
        this.removeEventListener('keydown', keydown);
        document.removeEventListener('shopify:block:select', blockSelect);
      };
      this.select(panels[0].dataset.guidePanel);
      tabs.hidden = false;
      const markers = this.querySelector('.park-product-explorer__markers');
      if (markers) markers.hidden = false;
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}
